import ChevronDownIcon from "@/User/Assets/Svgs/ChevronDownPrimaryIcon.svg";
import CloseWhiteIcon from "@/User/Assets/Svgs/CloseWhiteIcon.svg";
import MenuMobileIcon from "@/User/Assets/Svgs/MenuMobileBlackIcon.svg";
import HeaderButton from '@/User/Components/Header/HeaderButton';
import { RouteName } from "@/User/Constants/routes";
import { useTwilioClientContext } from "@/User/Contexts/TwilioClientContext";
import { router, usePage } from '@inertiajs/react';
import axios from "axios";
import classNames from "classnames";
import { values } from "lodash";
import React, { useState } from "react";
import route from "ziggy-js";
import { TextNotify } from "./DropdownNavbarPC";

export const MenuItem = ({ menu = {}, onClick = null, extendContent = null }) => (
    <li className={classNames("flex flex-row justify-between border-b border-iron px-4 py-3 mb-2 last:mt-2",
        {
            "bg-platinum": menu.options,
            "bg-white": !menu.options,
        }
    )}
    onClick={onClick}
    >
        <div className="flex flex-row">
            {menu.iconMobile && <div className='relative h-6 w-6'>{menu.iconMobile}</div>}
            {!menu.iconMobile && <img src={menu.srcIcon} width={24} height={24} />}
            <span className="whitespace-normal leading-6 text-xs font-semibold ml-1">{menu.mobileLabelText || menu.labelText}</span>
        </div>
        <div className="flex flex-row h-full items-center">
            {extendContent}
            <img src={ChevronDownIcon}
                className={classNames(
                    "transition-all duration-100 w-6 h-6",
                    {
                        "-rotate-180": menu.isActive && menu.options,
                        "-rotate-90": !menu.options,
                    }
                )}
                alt="Menu Item"
            />
        </div>
    </li>
);

export const SubMenuItem = ({ subMenu = {}, onClick = null, isActive = false }) => (
    <li className={`flex flex-row justify-between h-15.75 px-4 py-4 border border-iron bg-white ${!isActive && "!h-0 !py-0 border-none"} overflow-hidden transition-all duration-100`} onClick={onClick}>
        <div className="flex flex-row">
            <span className="whitespace-normal leading-7.25 text-xs text-primary ml-1">{subMenu.text}</span>
        </div>
        <div className="flex flex-row gap-2 h-full items-center">
            {subMenu.notify && <TextNotify text={subMenu.notify} />}
            <img src={ChevronDownIcon} alt="Submenu Item" className="-rotate-90 w-6 h-6" />
        </div>
    </li>
);

const MenuMobile = ({
    headerMenu = {},
    className = "",
    toggleMenu = () => { }
}) => {
    const { auth: { user } } = usePage().props;
    const { unreadCount, resetTwilioClient } = useTwilioClientContext();

    const [showDropdownMenu, setShowDropdownMenu] = useState(false);
    const toggleDropdown = () => {
        setShowDropdownMenu(!showDropdownMenu);
    };

    const handleLogout = async () => {
        axios.post(route(RouteName.LogoutPage))
            .then(async () => {
                await resetTwilioClient();
                await setShowDropdownMenu(false);
                router.visit(route(RouteName.LoginPage));
            });
    };

    return (
        <ul className={className}>
            <li className="relative">
                <HeaderButton
                    labelText={headerMenu.Favorite.labelText}
                    srcIcon={headerMenu.Favorite.srcIcon}
                    iconClassName="h-6 w-6"
                    className="h-12.5 w-12.5"
                    textClassName="text-3xs mt-0"
                    onClick={headerMenu.Favorite.onClick}
                />
            </li>
            <li className="">
                {!showDropdownMenu && <HeaderButton
                    labelText="メニュー"
                    srcIcon={MenuMobileIcon}
                    className="h-12.5 w-12.5"
                    textClassName="text-3xs mt-0"
                    onClick={toggleDropdown}
                />}
                {showDropdownMenu && <HeaderButton
                    labelText="閉じる"
                    srcIcon={CloseWhiteIcon}
                    className="!bg-midnight !h-12.5 !w-12.5"
                    textClassName="!text-white text-3xs mt-0"
                    onClick={toggleDropdown}
                />}
                {showDropdownMenu &&
                    <div className="absolute top-full h-screen left-0 right-0" onClick={() => setShowDropdownMenu(false)}>
                        <div className='flex flex-col gap-2 w-full bg-midnight px-4 py-6 max-h-[calc(100vh-50px)] overflow-scroll no-scrollbar' onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}>
                            <span className="text-base leading-6 text-white">{user?.data?.full_name} 様</span>
                            <ul className="w-full">
                                {
                                    values(headerMenu).map((item, index) => (
                                        item.show && <React.Fragment key={index}>
                                            <MenuItem
                                                menu={item}
                                                onClick={item.options && item.options.length > 0 ? toggleMenu(item.name) : () => {
                                                    item.onClick();
                                                    setShowDropdownMenu(false);
                                                }}
                                                extendContent={
                                                    item.name === "Mail" &&
                                                    unreadCount.all > 0 &&
                                                    <span
                                                        className="rounded-full flex items-center justify-center h-6 min-w-6 px-0.5 leading-tight text-sm text-center font-semibold text-white bg-free-speech-red"
                                                    >
                                                        {unreadCount.all}
                                                    </span>
                                                }
                                            />
                                            {item.options && item.options.map((subMenu, indexSubMenu) => (
                                                <SubMenuItem subMenu={subMenu} key={indexSubMenu} isActive={item.isActive} onClick={() => {
                                                    subMenu.onClick();
                                                    setShowDropdownMenu(false);
                                                }} />
                                            ))}
                                        </React.Fragment>
                                    ))
                                }
                            </ul>
                            <div className='w-full'>
                                <button
                                    className='text-white float-right underline underline-offset-2'
                                    onClick={() => handleLogout()}
                                >
                                    ログアウト
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </li>
        </ul>
    );
};

export default MenuMobile;
